import ServiceSec from "./ServiceSec";

export default function Segment3(){
    return(
    <div className="seg3">
        <ServiceSec/>
    </div>
    )
}